/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {
  Constants,
  NestedWorkflowWidgetConfiguration,
  WidgetNames,
} from '@finxone-platform/shared/sys-config-types';
import {
  addBeneFasterPaymentNestedWidgets,
  addBeneficiaryNestedWidget,
  editBeneficaryIntlNestedWidgets,
  editBeneficaryNestedWidgets,
  intlBeneAddressNestedWidgets,
} from './beneficiary/beneficiary';
import { cardsNestedWidgets } from './cards/cards';
import { conditionalNestedWidgets } from './conditional/conditional';
import { exchangeCurrencyCountryNestedWidgets } from './exchange/exchange';
import { emailNestedWidgets } from './onboarding/email';
import { phoneNestedWidgets } from './onboarding/phone';
import { otpVerificationNestedWidgets } from './otp/otp';
import { forgotNestedWidgets, updateNestedWidgets } from './password/password';
import { downloadRangeNestedWidgets, enterEmailNestedWidgets } from './statement/statement';
import { txHistoryNestedWidgets } from './transaction-history/transaction-history';

export const nestedWidgetDefaults: {
  [key: string]: {
    [uniqueId: string]: NestedWorkflowWidgetConfiguration;
  };
} = {
  [WidgetNames.RECENT_TRANSACTION_LIST_WIDGET]: txHistoryNestedWidgets,
  [WidgetNames.OTP_VERIFICATION]: otpVerificationNestedWidgets,
  [WidgetNames.CONDITIONAL_WIDGET]: conditionalNestedWidgets,
  [WidgetNames.CARDS_WIDGET]: cardsNestedWidgets,
  [WidgetNames.EDIT_BENEFICIARY_WIDGET]: editBeneficaryNestedWidgets,
  [WidgetNames.EDIT_INTERNATIONAL_BENEFICIARY_CREDENTIALS_WIDGET]: editBeneficaryIntlNestedWidgets,
  [WidgetNames.PHONE_WIDGET]: phoneNestedWidgets,
  [WidgetNames.EMAIL_WIDGET]: emailNestedWidgets,
  [WidgetNames.ADD_BENEFICIARY_FASTER_PAYMENTS]: addBeneFasterPaymentNestedWidgets,
  [WidgetNames.ADD_BENEFICIARY_WIDGET]: addBeneficiaryNestedWidget,
  [WidgetNames.INTL_BENEFICIARY_ADDRESS]: intlBeneAddressNestedWidgets,
  [WidgetNames.INTERNATIONAL_BENEFICIARY_CREDENTIALS_WIDGET]: {
    continueButton: {
      name: WidgetNames.BUTTON,
      widgetConfigDisplayName: 'Continue Button Styling',
      attributes: {
        widgetProperties: {
          textContent: 'Continue',
        },
        elementsConfig: [],
        css_config: {
          ...Constants.defaultUiNestedButtonCssConfig,
          verticalAlignment: 'center',
        },
      },
    },

    previousButton: {
      name: WidgetNames.BUTTON,
      widgetConfigDisplayName: 'Previous Button Styling',
      attributes: {
        widgetProperties: {
          textContent: 'Previous',
        },
        elementsConfig: [],
        css_config: {
          ...Constants.defaultUiNestedButtonCssConfig,
          backGroundColor: 'var(--palette-color-2)',
          color: 'var(--color-on-background)',
          borderWidth: 1,
          borderColor: 'var(--color-border-color)',
          borderStyle: 'solid',
          verticalAlignment: 'center',
          marginRight: 10,
          marginTop: 15,
        },
      },
    },

    nextButton: {
      name: WidgetNames.BUTTON,
      widgetConfigDisplayName: 'Next Button Styling',
      attributes: {
        widgetProperties: {
          textContent: 'Next',
        },
        elementsConfig: [],
        css_config: {
          ...Constants.defaultUiNestedButtonCssConfig,
          backGroundColor: 'var(--palette-color-2)',
          color: 'var(--color-on-background)',
          borderWidth: 1,
          borderColor: 'var(--color-border-color)',
          borderStyle: 'solid',
          verticalAlignment: 'center',
          marginLeft: 10,
          marginTop: 15,
        },
      },
    },
  },
  [WidgetNames.INTERNATIONAL_CURRENCY_COUNTRY]: exchangeCurrencyCountryNestedWidgets,
  [WidgetNames.RANGE_CALENDAR_WIDGET]: downloadRangeNestedWidgets,
  [WidgetNames.PASSWORD_FORGOT]: forgotNestedWidgets,
  [WidgetNames.PASSWORD_UPDATE]: updateNestedWidgets,
  [WidgetNames.PASSWORD_ENTER_EMAIL]: enterEmailNestedWidgets,
};
